import React, { Component } from "react";
import {
    getUsers,
    getQr,
    getBuildData,
    setEnvBuild,
    getJobPacks,
    redirectTo,
} from "./actions";
import { Typography, Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import { DisplayWidget } from "../UI/DisplayWidget";

import BuildIcon from "@material-ui/icons/Cached";
import { get } from "lodash";

class TotalClientInfoWidget extends Component {
    constructor(props) {
        super(props);

        props.setEnvBuild(get(process.env, "REACT_APP_BUILD_VERSION") || null);
    }

    render() {
        const { lg, md, sm, build } = this.props;

        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <DisplayWidget
                    color="white"
                    background="#8801cc"
                    Icon={BuildIcon}
                    primaryText={
                        <Typography
                            variant="subtitle1"
                            style={{ color: "inherit" }}
                        >
                            <b>Dashboard Build: </b>
                            {build.dashboard_client_build
                                ? build.dashboard_client_build
                                : "1.0.0"}
                        </Typography>
                    }
                    secondaryText={
                        <Typography
                            variant="subtitle1"
                            style={{ color: "inherit" }}
                        >
                            <b>App Build: </b>
                            {`${build.build ? build.build : "1.0.0"}`}
                        </Typography>
                    }
                />
            </Grid>
        );
    }
}

export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const {
                selectDashDetails,
                selectBuild,
                selectBuildStatus,
            } = selectors;
            return {
                details: selectDashDetails(store),
                build: selectBuild(store),
                status: selectBuildStatus(store),
            };
        },
        { getUsers, getQr, getBuildData, setEnvBuild, getJobPacks, redirectTo }
    )(TotalClientInfoWidget)
);
